// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__Zz9R3","inputDescription":"styles_inputDescription__1xRlF"};